import {Component, OnInit, TemplateRef, ViewChild, inject, output, input, linkedSignal} from '@angular/core';
import {FileService} from '../file.service';
import {DomSanitizer} from '@angular/platform-browser';
import dayjs from 'dayjs';
import {UserService} from '../../../services/user.service';
import {DataService} from '../../../services/data.service';
import {myAppConfig} from '../../../../settings';
import {FwFileViewLayout} from '../file.component';
import {FileModalComponent} from '../file-modal/file-modal.component';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {NgIf, NgFor, NgSwitch, NgSwitchCase, NgSwitchDefault, DatePipe} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SafeHtmlPipe} from '../../../pipes/safe-html.pipe';
import {FileSizePipe} from '../../../pipes/file-size.pipe';

dayjs.extend(customParseFormat);

@Component({
    selector: 'app-file-viewer',
    templateUrl: './file-viewer.component.html',
    styleUrl: './file-viewer.component.scss',
    imports: [
        NgIf, NgFor, FormsModule, NgSwitch, NgSwitchCase, NgSwitchDefault, FileModalComponent, DatePipe,
        SafeHtmlPipe, FileSizePipe,
    ]
})
export class FileViewerComponent implements OnInit {

    private dataService = inject(DataService);
    private userService = inject(UserService);
    private fileService = inject(FileService);
    private sanitizer = inject(DomSanitizer);
    private modalService = inject(BsModalService);

    files = input<any>();
    viewReadonly = input<boolean>(false);
    viewThumbnailsSize = input<string | null>(null);
    viewThumbnailsTilesSize = input<string | null>(null);
    viewThumbnailsTitle = input<boolean>(true);
    viewFullscreen = input<boolean>(false);
    viewShowFileInfo = input<boolean>(true); // Show Fileinfo in Image Viewer Fullscreen Mode
    viewEditModeFlipImage = input<boolean>(false); // allow Flip Image
    viewNoFilesText = input<string | null>(null);
    viewLayout = input<FwFileViewLayout>(FwFileViewLayout.TILES);
    localViewLayout = linkedSignal(() => this.viewLayout());

    showViewLayoutSwitcher = input<boolean>(false);
    onlyCreatorCanDelete = input<boolean>(false);
    enableLinks = input<boolean>(false);
    viewCheckbox = input<boolean>(false);

    // if set to true allows user to delete
    isAdmin = input<boolean>(false);

    readonly deleted = output();
    readonly selectedChange = output<any>();

    protected readonly myAppConfig = myAppConfig;

    fileViewLayout = FwFileViewLayout;

    @ViewChild('fileModalComponent') fileModalComponent!: FileModalComponent;

    @ViewChild('deleteTemplate') deleteTemplate!: TemplateRef<any>;
    modalDeleteRef?: BsModalRef;

    // DATA
    result: any = [];
    randomID!: string;

    ngOnInit(): void {
        this.randomID = (Math.random() * 1000).toFixed(0);
    }

    canBeDeleted(file: any): boolean {
        // admin can always delete
        if (this.isAdmin()) {
            return true;
        }

        // if readonly don't allow
        if (this.viewReadonly()) {
            return false;
        }

        return this.onlyCreatorCanDelete() === false || (this.onlyCreatorCanDelete() === true && file.create_UID === this.userService.currentUser.UID);
    }

    openDeleteFileModal(event: any, file: any): void {
        event.stopPropagation();
        this.dataService.request('framework.File/getFile', {
            FID: file.FID,
            thumbnail: false
        }).subscribe(response => {
            this.result.selectedFile = response.file;

            if (this.result.selectedFile.firstname !== null) {
                this.result.selectedFile.creator_name = this.result.selectedFile.firstname + ' ' + this.result.selectedFile.lastname;
            }

            if (this.userService.currentUser.language === 'de') {
                this.result.selectedFile.create_date = dayjs(this.result.selectedFile.create_date, 'YYYY-MM-DD HH:mm:ss').format(
                    'DD.MM.YYYY HH:mm'
                );
            }
            this.result.selectedFile.imgData = this.sanitizer.bypassSecurityTrustUrl(file.imgData);
            this.modalDeleteRef = this.modalService.show(this.deleteTemplate);

        });
    }

    deleteFile(file: any): void {
        this.modalDeleteRef?.hide();
        this.dataService.request('framework.File/deleteFile', {
            FID: file.FID,
        }).subscribe(() => {
            this.fileService.loadFiles.next(true);
            this.fileService.deselectFiles.next(true);
            this.fileService.countUploadedFiles.next(true);
            this.deleted.emit();
        });
    }

    openFileModal(FID: any): void {
        this.fileService.openModal.next(FID);

        this.fileModalComponent.openFile(FID);
    }

    setLayout(fileViewLayout: FwFileViewLayout): void {
        this.localViewLayout.set(fileViewLayout);
    }

    handleSelectedChange() {
        this.selectedChange.emit(this.files().filter((file: any) => file.selected).map((file: any) => {
            return {
                FID: file.FID,
                name: file.name,
            }
        }));
    }
}
